export class calendarConfig
{
    static dailyStartTime = "00:00";
    static dailyEndTime = "24:00";
    static dailyWorkStartTime = "08:00";
    static dailyWorkEndTime = "18:00";
    static intervalToShowInMinutes = 30;
}